<div class="welcome-guest-wrapper">
  <h1>Welcome to Rebuilt</h1>
  <p>Get unrestricted access to the marketplace.</p>

  <ul>
    <li>
      <img
        src="/assets/images/modules/auth-v2/markets.svg"
        alt="multiple markers"
      />
      Multiple markets
    </li>
    <li>
      <img
        src="/assets/images/modules/auth-v2/policy.svg"
        alt="multiple markers"
      />
      Curated investment deals
    </li>
    <li>
      <img
        src="/assets/images/modules/auth-v2/user.svg"
        alt="multiple markers"
      />
      1,000+ Sellers
    </li>
    <li>
      <img
        src="/assets/images/modules/auth-v2/eco.svg"
        alt="multiple markers"
      />
      Consistent deal flow
    </li>
  </ul>
</div>
